import { currencySlice } from "./currencySlice";
import * as defaultActions from "../../../../../redux/_common";

export const QPARAMS_CHANGED = "currencies/QParamsChanged";
const { actions } = currencySlice;
const moduleUrl = '/api/appmasterdata/currencies'

export const setValidationErrors = actions.setValidationErrors;

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
